const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 70,
    height: 70,
    backgroundColor: '#494949',
    color: "#B8B8B8",
    boxShadow: 24,
    borderRadius: 10,
    p: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

export { style };